import React from "react";

const BoardSidePane = () => {
  return (
    <div className="flex-flex-col">
      <div className="w-64 flex flex-row lg:flex-col justify-center items-center">
        Content goes here
      </div>
    </div>
  );
};

export default BoardSidePane;
